import { apiRequests } from '../utilities/axios-factory'
import store from '../store'

function getAlternateIdentifier (id, filter) {
  return apiRequests.get('/v1/passenger-alternate-identifier/' + id + '/', {
    params: { filter },
    headers: { 'Authorization': store.getters.getTokenId }
  }).then((result) => {
    return result.data
  })
}

function getAlternateIdentifiers ({ passengerProfileId, filter }) {
  filter = {
    order: 'dateUpdated DESC',
    ...filter
  }

  if (passengerProfileId) {
    filter.where = filter.where || {}
    filter.where.passengerProfileId = passengerProfileId
  }

  return apiRequests.get('/v1/passenger-alternate-identifier/', {
    params: { filter: Object.keys(filter).length ? filter : undefined },
    headers: { 'Authorization': store.getters.getTokenId }
  }).then((result) => {
    return result.data
  })
}

function getArchivedOrUnarchivedAlternateIdentifier (id, filter) {
  return apiRequests.get('/v1/raw-passenger-alternate-identifier/' + id + '/', {
    params: { filter },
    headers: { 'Authorization': store.getters.getTokenId }
  }).then((result) => {
    return result.data
  })
}

function getArchivedOrUnarchivedAlternateIdentifiers ({ passengerProfileId, filter }) {
  filter = {
    order: 'dateUpdated DESC',
    ...filter
  }

  if (passengerProfileId) {
    filter.where = filter.where || {}
    filter.where.passengerProfileId = passengerProfileId
  }

  return apiRequests.get('/v1/raw-passenger-alternate-identifier/', {
    params: { filter: Object.keys(filter).length ? filter : undefined },
    headers: { 'Authorization': store.getters.getTokenId }
  }).then((result) => {
    return result.data
  })
}

function unregisterAlternateIdentifier (idOrOptions, identifierType) {
  const options = typeof idOrOptions === 'object' && idOrOptions
    ? idOrOptions
    : { id: idOrOptions, identifierType }

  const resolvedIdentifierType = options.identifierType || 'ble'

  return apiRequests.delete('/v1/passenger-alternate-identifier/' + options.id + '/' + resolvedIdentifierType + '/', {
    headers: { 'Authorization': store.getters.getTokenId }
  }).then((result) => {
    return result.data
  })
}

function unregisterAlternateIdentifierByType ({ id, identifierType }) {
  return unregisterAlternateIdentifier({ id, identifierType })
}

function registerAlternateIdentifier ({ passengerProfileId, identifierKey, identifierType }) {
  const resolvedIdentifierType = identifierType || 'ble'

  const body = {
    metadata: { registeredVia: 'adminPortal' }
  }

  if (resolvedIdentifierType === 'rfid') {
    body.epc = identifierKey
  } else {
    body.macAddress = identifierKey
  }

  return apiRequests.post('/v1/passenger-profile/' + passengerProfileId + '/passenger-alternate-identifier/' + resolvedIdentifierType + '/', body, {
    headers: { 'Authorization': store.getters.getTokenId }
  }).then((result) => {
    return result.data
  })
}

function checkBeaconRegistrationEligibility ({ passengerProfileId }) {
  return apiRequests.get('/v1/passenger-profile/' + passengerProfileId + '/beacon-registration-eligibility/', {
    headers: { 'Authorization': store.getters.getTokenId }
  }).then((result) => {
    return result.data
  })
}

export {
  getAlternateIdentifier,
  getAlternateIdentifiers,
  getArchivedOrUnarchivedAlternateIdentifier,
  getArchivedOrUnarchivedAlternateIdentifiers,
  unregisterAlternateIdentifier,
  unregisterAlternateIdentifierByType,
  registerAlternateIdentifier,
  checkBeaconRegistrationEligibility
}
